/**
 * Abre un PDF de jsPDF en otra pestaña en vez de descargarlo.
 *
 * Sustituye a `doc.save(nombre)` en todo el sistema. Se conserva el nombre
 * como segundo argumento porque sigue haciendo falta en dos casos: el título
 * que ve el usuario en el visor, y la descarga de respaldo.
 *
 * Sobre el respaldo: si el PDF se arma después de un `await`, el navegador ya
 * no considera la apertura como consecuencia del clic y bloquea la pestaña.
 * En vez de dejar al usuario sin nada, se descarga como antes.
 */
export function abrePDF(doc, nombre = "documento.pdf") {
  const limpio = String(nombre || "documento.pdf").replace(/\.pdf$/i, "");

  try {
    // La pestaña de un blob: muestra el UUID en la barra, pero el visor de
    // PDF usa este título para encabezar la vista y para sugerir el nombre
    // cuando el usuario decide guardarlo desde ahí.
    doc.setProperties({ title: limpio });
  } catch (e) {
    // setProperties no está en todas las versiones; no es razón para no abrirlo.
  }

  try {
    // Ojo: si el navegador no soporta createObjectURL, jsPDF NO lanza error:
    // avisa por consola y devuelve undefined. Sin este guard se abriría una
    // pestaña en blanco y el catch nunca entraría.
    const url = doc.output("bloburl");
    if (!url) {
      doc.save(nombre);
      return;
    }

    const ventana = window.open(String(url), "_blank");
    if (!ventana || ventana.closed) {
      doc.save(nombre);
      URL.revokeObjectURL(String(url));
      return;
    }

    // jsPDF deja la liberación al que lo llama. No se puede revocar de
    // inmediato (la pestaña todavía no termina de leer el blob), así que se
    // espera un minuto: de sobra para que cargue, y evita ir acumulando
    // varios MB por cada PDF que se genera en la sesión.
    setTimeout(() => {
      try {
        URL.revokeObjectURL(String(url));
      } catch (e) {
        // Si ya se liberó o el navegador no deja, no hay nada que hacer.
      }
    }, 60000);
  } catch (e) {
    doc.save(nombre);
  }
}

export default abrePDF;
